/* tslint:disable */
import {
  Partner,
  PartnerAddress,
  PurchaseRequisitionLine,
  Company,
  StockWarehouseLocation,
  DeliveryCarrier,
  LerOperatorType,
  LerOperationType
} from '../index';

declare var Object: any;
export interface PurchaseRequisitionInterface {
  "id"?: number;
  "name"?: string;
  "partner_id"?: number;
  "state"?: string;
  "gps_position_id"?: number;
  "gallery_id"?: number;
  "transport_price"?: number;
  "commercial_company"?: string;
  "date_start"?: Date;
  "related_images_counter"?: number;
  "origin_address_id"?: number;
  "destination_address_id"?: number;
  "operator_address_id"?: number;
  "authorized_origin_address_id"?: number;
  "authorized_destination_address_id"?: number;
  "ler_operator_type_id"?: number;
  "purchase_req_type"?: string;
  "ler_operation_type_id"?: number;
  "warehouse_id"?: number;
  "location_id"?: number;
  "line_ids"?: Array<any>;
  "company_id"?: number;
  "warehouse_location_id"?: number;
  "carrier_id"?: number;
  "origin_operator_type_id"?: number;
  "operator_operator_type_id"?: number;
  partner?: Partner;
  origin_address?: PartnerAddress;
  authorized_origin_address?: PartnerAddress;
  destination_address?: PartnerAddress;
  authorized_destination_address?: PartnerAddress;
  operator_address?: PartnerAddress;
  lines?: PurchaseRequisitionLine[];
  company?: Company;
  warehouse_location?: StockWarehouseLocation;
  carrier?: DeliveryCarrier;
  ler_operator_type?: LerOperatorType;
  origin_operator_type?: LerOperatorType;
  operator_operator_type?: LerOperatorType;
  ler_operation_type?: LerOperationType;
}

export class PurchaseRequisition implements PurchaseRequisitionInterface {
  "id": number;
  "name": string;
  "partner_id": number;
  "state": string;
  "gps_position_id": number;
  "gallery_id": number;
  "transport_price": number;
  "commercial_company": string;
  "date_start": Date;
  "related_images_counter": number;
  "origin_address_id": number;
  "destination_address_id": number;
  "operator_address_id": number;
  "authorized_origin_address_id": number;
  "authorized_destination_address_id": number;
  "ler_operator_type_id": number;
  "purchase_req_type": string;
  "ler_operation_type_id": number;
  "warehouse_id": number;
  "location_id": number;
  "line_ids": Array<any>;
  "company_id": number;
  "warehouse_location_id": number;
  "carrier_id": number;
  "origin_operator_type_id": number;
  "operator_operator_type_id": number;
  partner: Partner;
  origin_address: PartnerAddress;
  authorized_origin_address: PartnerAddress;
  destination_address: PartnerAddress;
  authorized_destination_address: PartnerAddress;
  operator_address: PartnerAddress;
  lines: PurchaseRequisitionLine[];
  company: Company;
  warehouse_location: StockWarehouseLocation;
  carrier: DeliveryCarrier;
  ler_operator_type: LerOperatorType;
  origin_operator_type: LerOperatorType;
  operator_operator_type: LerOperatorType;
  ler_operation_type: LerOperationType;
  constructor(data?: PurchaseRequisitionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PurchaseRequisition`.
   */
  public static getModelName() {
    return "PurchaseRequisition";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PurchaseRequisition for dynamic purposes.
  **/
  public static factory(data: PurchaseRequisitionInterface): PurchaseRequisition{
    return new PurchaseRequisition(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PurchaseRequisition',
      plural: 'PurchaseRequisitions',
      path: 'PurchaseRequisitions',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "gps_position_id": {
          name: 'gps_position_id',
          type: 'number'
        },
        "gallery_id": {
          name: 'gallery_id',
          type: 'number'
        },
        "transport_price": {
          name: 'transport_price',
          type: 'number'
        },
        "commercial_company": {
          name: 'commercial_company',
          type: 'string'
        },
        "date_start": {
          name: 'date_start',
          type: 'Date'
        },
        "related_images_counter": {
          name: 'related_images_counter',
          type: 'number'
        },
        "origin_address_id": {
          name: 'origin_address_id',
          type: 'number'
        },
        "destination_address_id": {
          name: 'destination_address_id',
          type: 'number'
        },
        "operator_address_id": {
          name: 'operator_address_id',
          type: 'number'
        },
        "authorized_origin_address_id": {
          name: 'authorized_origin_address_id',
          type: 'number'
        },
        "authorized_destination_address_id": {
          name: 'authorized_destination_address_id',
          type: 'number'
        },
        "ler_operator_type_id": {
          name: 'ler_operator_type_id',
          type: 'number'
        },
        "purchase_req_type": {
          name: 'purchase_req_type',
          type: 'string'
        },
        "ler_operation_type_id": {
          name: 'ler_operation_type_id',
          type: 'number'
        },
        "warehouse_id": {
          name: 'warehouse_id',
          type: 'number'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "line_ids": {
          name: 'line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
        "carrier_id": {
          name: 'carrier_id',
          type: 'number'
        },
        "origin_operator_type_id": {
          name: 'origin_operator_type_id',
          type: 'number'
        },
        "operator_operator_type_id": {
          name: 'operator_operator_type_id',
          type: 'number'
        },
      },
      relations: {
        partner: {
          name: 'partner',
          type: 'Partner',
          model: 'Partner',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        origin_address: {
          name: 'origin_address',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'origin_address_id',
          keyTo: 'id'
        },
        authorized_origin_address: {
          name: 'authorized_origin_address',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'authorized_origin_address_id',
          keyTo: 'id'
        },
        destination_address: {
          name: 'destination_address',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'destination_address_id',
          keyTo: 'id'
        },
        authorized_destination_address: {
          name: 'authorized_destination_address',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'authorized_destination_address_id',
          keyTo: 'id'
        },
        operator_address: {
          name: 'operator_address',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'operator_address_id',
          keyTo: 'id'
        },
        lines: {
          name: 'lines',
          type: 'PurchaseRequisitionLine[]',
          model: 'PurchaseRequisitionLine',
          relationType: 'referencesMany',
                  keyFrom: 'line_ids',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        warehouse_location: {
          name: 'warehouse_location',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        carrier: {
          name: 'carrier',
          type: 'DeliveryCarrier',
          model: 'DeliveryCarrier',
          relationType: 'belongsTo',
                  keyFrom: 'carrier_id',
          keyTo: 'id'
        },
        ler_operator_type: {
          name: 'ler_operator_type',
          type: 'LerOperatorType',
          model: 'LerOperatorType',
          relationType: 'belongsTo',
                  keyFrom: 'ler_operator_type_id',
          keyTo: 'id'
        },
        origin_operator_type: {
          name: 'origin_operator_type',
          type: 'LerOperatorType',
          model: 'LerOperatorType',
          relationType: 'belongsTo',
                  keyFrom: 'origin_operator_type_id',
          keyTo: 'id'
        },
        operator_operator_type: {
          name: 'operator_operator_type',
          type: 'LerOperatorType',
          model: 'LerOperatorType',
          relationType: 'belongsTo',
                  keyFrom: 'operator_operator_type_id',
          keyTo: 'id'
        },
        ler_operation_type: {
          name: 'ler_operation_type',
          type: 'LerOperationType',
          model: 'LerOperationType',
          relationType: 'belongsTo',
                  keyFrom: 'ler_operation_type_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PurchaseRequisition.ts